.form {
    display: flex;
    width: 100%;
    font-family: var(--tempest-font-sans);
}

.form.stack {
    flex-direction: column;
}

.form.inline {
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
}

.form.grid {
    display: grid;
    width: 100%;
}

.section {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.sectionHeader {
    display: flex;
    flex-direction: column;
    margin-bottom: var(--tempest-space-3);
}

.sectionTitle {
    font-size: var(--tempest-text-lg);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
    margin: 0;
}

.sectionDescription {
    font-size: var(--tempest-text-sm);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
    margin: var(--tempest-space-1) 0 0;
}

.sectionBody {
    display: flex;
    width: 100%;
}

.sectionBody.stack {
    flex-direction: column;
}

.sectionBody.inline {
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
}

.sectionBody.grid {
    display: grid;
}

.row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
    width: 100%;
}

.row > * {
    flex: 1 1 0;
    min-width: 0;
}

/* On mobile, rows collapse to single column for legibility. */
@media (max-width: 639.98px) {
    .row {
        flex-direction: column;
        align-items: stretch;
    }
    .row > * {
        flex: 1 1 auto;
    }
}

.actions {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: var(--tempest-space-2);
}

.actions.start {
    justify-content: flex-start;
}

.actions.center {
    justify-content: center;
}

.actions.end {
    justify-content: flex-end;
}

.actions.between {
    justify-content: space-between;
}
